import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { adminUserDomainDetails } from "../../Services/postServices";
import { loader } from "../../redux/type";
const AdminSchemeDetails = () => {
  const dispatch = useDispatch();
  const token=localStorage.getItem("token");

  const userData = JSON.parse(localStorage.getItem("user"));
  //   console.log("DATATATA=", userData?.user?.id);
  // const id=userData?.user?.id

  // const id=userData?.domainCodesByUserId[0]?.userId

  // const id = userData?.domainCodesByUserId[0]?.userId;
  const id = userData?.user?.userId;
  const mobileNo1 = userData?.user?.mobile;
  const emailId = userData?.user?.emailId;

  useEffect(() => {
    domain();
  }, []);

  const [deptApp, setDeptApp] = useState([]);

  function domain() {
    dispatch({ type: loader.startLoader });
    // let userId=1791
    let req = {
      userId: id,
      mobileNo: mobileNo1,
      email: emailId,
    };

    adminUserDomainDetails(req, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        setDeptApp(res?.data?.result?.deptApplicationList);
        console.log(
          "domain details=",
          res?.data?.result?.deptApplicationList[0]?.application
        );
      } else {
        console.log(res);
      }
    });
  }

  return (
    <div className="card shadow myprofileCard ">
      <div className="card-body overFlow p-md-3">
        <h5 className="h2_heading">DDA Departments</h5>
        <br></br>
        <br></br>

        <div className="row marTop">
          <h5>
            {deptApp[0]?.departmentName} Application
          </h5>

          {deptApp?.map((va, i) => (
            <>
              {deptApp[i]?.application?.map((val, j) => (

                <div key={j} className="row marTop">
                  <div className="col-12 card shadow">
                    <div className="card-body">
                      <div className="sameLine2">
                        <img
                          src={"http://4.224.85.195" + val?.icon}
                          className="iconSize2 "
                          alt="delhi"
                        />
                      </div>

                      <div className="sameLine2">
                        <h5>{val?.applicationName}</h5>
                        <p style={{ fontSize: "10px" }}>{val?.description}</p>
                      </div>
                      <div className="sameLine2" style={{ float: "right" }}>

                        {console.log("WaterBill8899",`${val?.url}?token=${token}`)}
                        
                        <a
                        //   href={val?.url}
                          href={`${val?.url}?token=${token}`}
                          
                          target="_blank"
                          alt="Link Not working"
                        >
                          {" "}
                          {/* <Link
                            to={"/" + val?.domainCode}
                            state={{
                              url_Link: val?.url,
                              doCode: val?.domainCode,
                            }}
                          > */}
                          
                            <button className="btn btn-primary">Open</button>
                          {/* </Link> */}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            </>
          ))}
        </div>
      </div>
    </div>
  );
};
export default AdminSchemeDetails;
